import { ISymbol } from '@cbridge-packages/symbol';
import { IApiErrorParams } from '@cbridge-packages/api';
import { MarkupType } from '@cbridge-packages/markup';
import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolListResponseCounters } from '@cbridge-utils/datagrid';
import { IOption } from '@cbridge-utils/options';
import { IClientLp } from '@cbridge-packages/lp-client';
import { IScheduleFullView } from '@cbridge-packages/schedule';

export interface ISymbolLp {
  name: string;
  coreSymbolId: ISymbol['symbolId'];
  coreSymbolName: ISymbol['name'];
  priceMultiplier: number;
  volumeMultiplier: number;
  bidMarkup: number;
  askMarkup: number;
  markupType: MarkupType;
  minVolume: number;
  maxVolume: number;
  stepVolume: number;
  schedule?: IScheduleFullView;
}

export enum LpSymbolsFilter {
  Mapped = 'mapped',
  Unmapped = 'unmapped',
}

export enum LpSymbolColumn {
  Name = 'name',
  CoreSymbolName = 'coreSymbolName',
  BidMarkup = 'bidMarkup',
  AskMarkup = 'askMarkup',
  MarkupType = 'markupType',
  MinVolume = 'minVolume',
  StepVolume = 'stepVolume',
  MaxVolume = 'maxVolume',
  PriceMultiplier = 'priceMultiplier',
  VolumeMultiplier = 'volumeMultiplier',
}

export interface ISymbolLpIdentifier {
  lpId: IClientLp['lpId'];
  name: ISymbolLp['name'];
}

export interface ISymbolLpKey {
  lpId: IClientLp['lpId'];
  limit?: number;
  skip?: number;
  symbolGroup?: string;
  filter?: LpSymbolsFilter;
  search?: string;
  sort?: string[];
}

export interface IUnmappedSymbolsKey {
  lpId: IClientLp['lpId'];
  search?: string;
}

export interface ISymbolLpList extends ISymbolListResponseCounters {
  items: ISymbolLp[];
}

export type ILpSymbolName = IOption<ISymbol['symbolId']>;

export interface ISymbolLpStoreData extends ISymbolLp {
  networkStatus?: NetworkStatus;
}

export interface ISymbolLpStore {
  data: Record<string/*Composite ID: LP ID + Symbol name*/, ISymbolLpStoreData>;
  unmappedSymbols: {
    list: ILpSymbolName[];
    networkStatus: NetworkStatus;
  };
  counters: Record<string/* Serialized LP ID and filters */, ISymbolListResponseCounters>;
  networkStatus: NetworkStatus;
  listError?: IApiErrorParams;
}

export interface ISymbolLpStoreSegment {
  symbolLp: ISymbolLpStore;
}
